const config = {
  dev: process.env.REACT_APP_DEV === 'true',
  target: process.env.REACT_APP_TARGET || 'dev',
  platform: process.env.REACT_APP_PLATFORM || 'SC', /** SC: 誉存平台，HL: 华龙平台 */
  basename: process.env.PUBLIC_URL || '/',
}

export default config;
